import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 30,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 11,
		cy: 11,
		r: 11,
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.3462 10.9777L15.3459 7.97795C15.4179 7.90594 15.4179 7.78921 15.3459 7.7172L14.2377 6.60872C14.2031 6.57414 14.1561 6.55469 14.1073 6.55469C14.0585 6.55469 14.0115 6.57414 13.9769 6.60872L10.9771 9.60858L7.97722 6.60872C7.90807 6.53957 7.78562 6.53957 7.71647 6.60872L6.60818 7.7172C6.53617 7.78921 6.53617 7.90594 6.60818 7.97795L9.60795 10.9777L6.60818 13.9775C6.53617 14.0495 6.53617 14.1662 6.60818 14.2382L7.71647 15.3466C7.75105 15.3812 7.79798 15.4007 7.84685 15.4007C7.89572 15.4007 7.94265 15.3812 7.97722 15.3466L10.9771 12.3468L13.9769 15.3466C14.0115 15.3812 14.0585 15.4007 14.1073 15.4007C14.1561 15.4007 14.2031 15.3812 14.2377 15.3466L15.346 14.2382C15.418 14.1662 15.418 14.0494 15.346 13.9775L12.3462 10.9777Z",
		fill: "white"
	})]
});
export default SvgClose;
